/**
 * Axios configuration for Dealer's Sellers API
 * @module SellersAPI
 *
 * This a public API in the dealerappcenter organization
 * The purpose is to retrieve information of dealer's sellers
 */

import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_ROOFTOP_ENDPOINT}`,
});

export default instance;
